import logo from "./logo.svg";
//import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import {BrowserRouter,Routes,Route} from "react-router-dom";
import Home from "./ui/pages/HomePage/HomePage";
import Contact from "./ui/pages/HomePage/Contact";
import Mision from "./ui/pages/AboutEnterprise/Mision";
import Page404 from "./ui/pages/HomePage/PageNotFound";
import AboutUs from "./ui/pages/AboutEnterprise/AboutUs";
import Gallery from "./ui/pages/Gallery/Gallery";
import Services from "./ui/pages/Services/Services";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home/>}></Route>
        <Route path="/contact" element={<Contact/>}></Route>
        <Route path="/mission" element={<Mision/>}></Route>
        <Route path="/aboutus" element={<AboutUs/>}></Route>
        <Route path="/portfolio/gallery" element={<Gallery/>}></Route>
        <Route path="/services" element={<Services/>}></Route>
        <Route path="*" element={Page404} />
      </Routes>
      {/**
       * <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
    </div>
       */}
    </BrowserRouter>
  );
}

export default App;
